import { node_observable_component } from 'common/util/ComponentDecorator';
@node_observable_component
export default class orderDialog {
    static classname = 'order-dialog-decorator';

    constructor($decorator) {
        const $filters = $decorator.find('.wa-filters-wrapper');

        if ($filters.length) {
            $filters.html($filters.html().replace('&quot;', ''))
        }

        $decorator.find('.wa-close-wrapper').addClass('modal__close');
        $decorator.find('.wa-order-dialog').addClass('modal__inner');
        $decorator.find('.wa-header').addClass('modal__title');
        $decorator.find('.wa-button').addClass('btn');
        $decorator.find('a').addClass('link');
        $decorator.find('.wa-variants-list').on('touchmove', (e) => {
            e.stopPropagation()
        })
    }
}
